"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _getComponentName = _interopRequireDefault(require("react-utils/getComponentName"));

var withTinyMcePopoverLifecycle = function withTinyMcePopoverLifecycle(WrappedComponent) {
  var TinyMcePopoverLifecycle =
  /*#__PURE__*/
  function (_Component) {
    (0, _inherits2.default)(TinyMcePopoverLifecycle, _Component);

    function TinyMcePopoverLifecycle(props) {
      var _this;

      (0, _classCallCheck2.default)(this, TinyMcePopoverLifecycle);
      _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TinyMcePopoverLifecycle).call(this, props));
      _this.handleEditorBlur = _this.handleEditorBlur.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleEditorRemove = _this.handleEditorRemove.bind((0, _assertThisInitialized2.default)(_this));
      return _this;
    }

    (0, _createClass2.default)(TinyMcePopoverLifecycle, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this$props = this.props,
            onRemove = _this$props.onRemove,
            editor = _this$props.editor; // When TinyMCE is is in inline mode, the popover and the target are rendered in the same
        // window so we don't have to worry about the target being masked by the parent window

        if (!editor.settings.inline) {
          // Toolbar components are rendered before the editor is setup - need to wait to add the events
          // if the editor's window is not yet available
          if (editor.getWin()) {
            editor.getWin().addEventListener('scroll', onRemove);
          } else {
            editor.on('init', function () {
              editor.getWin().addEventListener('scroll', onRemove);
            });
          }
        } // Add remove handler to the front of the event queue
        // so that the handler is more likely to run before the
        // iframe is destroyed


        editor.on('remove', this.handleEditorRemove, true);
        editor.on('blur', this.handleEditorBlur);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        var _this$props2 = this.props,
            onRemove = _this$props2.onRemove,
            editor = _this$props2.editor;

        if (!editor.removed) {
          editor.getWin().removeEventListener('scroll', onRemove);
          editor.off('remove', this.handleEditorRemove);
          editor.off('blur', this.handleEditorBlur);
        }
      }
    }, {
      key: "handleEditorBlur",
      value: function handleEditorBlur() {
        var onRemove = this.props.onRemove;
        setTimeout(onRemove);
      }
    }, {
      key: "handleEditorRemove",
      value: function handleEditorRemove() {
        var _this$props3 = this.props,
            onRemove = _this$props3.onRemove,
            editor = _this$props3.editor;

        if (!editor.settings.inline && editor.getWin() && editor.getWin().removeEventListener) {
          editor.getWin().removeEventListener('scroll', onRemove);
        }

        onRemove();
      }
    }, {
      key: "render",
      value: function render() {
        return _react.default.createElement(WrappedComponent, (0, _extends2.default)({
          className: "mce-hubspot-popover tinymce-popover",
          addTargetClasses: false,
          pinToConstraint: ['left', 'right', 'top', 'bottom']
        }, this.props));
      }
    }]);
    return TinyMcePopoverLifecycle;
  }(_react.Component);

  TinyMcePopoverLifecycle.propTypes = {
    editor: _react.PropTypes.object.isRequired,
    onRemove: _react.PropTypes.func
  };
  TinyMcePopoverLifecycle.defaultProps = {
    onRemove: function onRemove() {}
  };
  TinyMcePopoverLifecycle.displayName = "TinyMcePopoverLifecycle(" + (0, _getComponentName.default)(WrappedComponent) + ")";
  return TinyMcePopoverLifecycle;
};

var _default = withTinyMcePopoverLifecycle;
exports.default = _default;
module.exports = exports.default;